import { render, staticRenderFns } from "./Mail-Tag-Selector.vue?vue&type=template&id=4fb20c46&lang=pug"
import script from "./Mail-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Mail-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports